import { FC } from 'react';
import SlickSlider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Slider: FC<Settings> = (props) => <SlickSlider {...props} />;

export default Slider;
